c<template>
  <div class="whs-breadcrumbs">
    <div class="whs-breadcrumbs-item" @click="navigate('home')">Поиск отелей</div>
    <div v-if="countryName" class="whs-breadcrumbs-item whs-icon is-not-clickable">{{ countryName }}</div>
    <div
      v-if="regionName"
      class="whs-breadcrumbs-item whs-icon is-not-clickable"
    >{{ regionName }}</div>
    <div v-if="hotelName" class="whs-breadcrumbs-item whs-icon">{{ hotelName }}</div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Breadcrumbs',
  props: {
    location: [Object, null]
  },
  computed: {
    ...mapState('hero', ['adults', 'children']),
    ...mapGetters('hero', ['checkin', 'checkout']),
    countryName() {
      return this.location !== null && this.location.country
        ? this.location.country.name
        : '';
    },
    regionName() {
      return this.location !== null && this.location.region
        ? this.location.region.name
        : '';
    },
    hotelName() {
      return this.location !== null && this.location.hotel
        ? this.location.hotel.name
        : '';
    }
  },
  methods: {
    navigate() {
      let path = '/';
      let query = '';

      this.$router.push({ path, query });
    }
  }
};
</script>

<style scoped>
.whs-breadcrumbs {
  padding: 12px 12px 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.whs-breadcrumbs-item {
  padding: 2px 8px 2px 0;
  color: var(--color-main);
  font-weight: 500;
  cursor: pointer;
}
.whs-breadcrumbs-item:last-child,
.whs-breadcrumbs-item.is-not-clickable {
  color: var(--color-text);
  font-weight: 400;
  cursor: default;
}
.whs-breadcrumbs-item.whs-icon:before {
  content: '\f054';
  color: var(--color-alt-5);
  margin-right: 8px;
}
</style>